export default __webpack_public_path__ + "static/media/space.516091e5.jpg";